"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteral(["\n  width: 100px;\n  position: relative;\n  z-index: 1;\n"], ["\n  width: 100px;\n  position: relative;\n  z-index: 1;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  bottom: 0;\n  height: 100px;\n  width: 100px;\n"], ["\n  ", ";\n  bottom: 0;\n  height: 100px;\n  width: 100px;\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  text-align: center;\n\n  img {\n    height: 100%;\n  }\n"], ["\n  display: inline-block;\n  position: relative;\n  text-align: center;\n\n  img {\n    height: 100%;\n  }\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  text-align: center;\n"], ["\n  text-align: center;\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n  z-index: 2;\n"], ["\n  ", ";\n  z-index: 2;\n"]),
    _templateObject7 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 50%;\n  bottom: 3px;\n  left: 3px;\n  position: absolute;\n  right: 3px;\n  top: 3px;\n"], ["\n  background-color: ", ";\n  border-radius: 50%;\n  bottom: 3px;\n  left: 3px;\n  position: absolute;\n  right: 3px;\n  top: 3px;\n"]);

var _arenaConfig = require("arena-config");

var c = _interopRequireWildcard(_arenaConfig);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _assets = require("../../../constants/assets");

var _propTypes = require("../propTypes");

var _mixins = require("./mixins");

var _propTypes2 = require("./propTypes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var bgSrc = (0, _assets.VECTOR_ICONS)('lockBg');
var fgSrc = (0, _assets.VECTOR_ICONS)('lockFg');
var shineSrc = (0, _assets.VECTOR_ICONS)('lockShine');

var Bg = _styledComponents2.default.div(_templateObject);

var Fg = _styledComponents2.default.div(_templateObject2, c.overlay(), _mixins.turnTheKnob);

var FgWrap = _styledComponents2.default.div(_templateObject3, c.absoluteCenter(true, false));

var Inner = _styledComponents2.default.div(_templateObject4);

var Outer = _styledComponents2.default.div(_templateObject5);

var Shine = _styledComponents2.default.div(_templateObject6, c.overlay());

var Spinner = _styledComponents2.default.div(_templateObject7, function (props) {
  return c.color(props);
});

var Lock = function Lock(props) {
  return _react2.default.createElement(Outer, null, _react2.default.createElement(Inner, null, _react2.default.createElement(FgWrap, null, _react2.default.createElement(Spinner, props), _react2.default.createElement(Shine, null, _react2.default.createElement("img", {
    src: shineSrc
  })), _react2.default.createElement(Fg, null, _react2.default.createElement("img", {
    src: fgSrc
  }))), _react2.default.createElement(Bg, null, _react2.default.createElement("img", {
    src: bgSrc
  }))));
};

Lock.defaultProps = _extends({}, _propTypes.animationCommonDefaultProps, _propTypes2.lockDefaultProps);
Lock.propTypes = _extends({}, _propTypes.animationCommonPropTypes, _propTypes2.lockPropTypes);
exports.default = Lock;